import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './ManageEnterpriseSubscription.scss';
import BuyCreditsModal from '../BuyCreditsModal/BuyCreditsModal';

const ManageEnterpriseSubscription = ({
    visible,
    onClose,
    onViewContract,
    onBuyCredits,
    onContactSales,
    onCancelSubscription,
    planData
}) => {
    const [buyCreditsModalVisible, setBuyCreditsModalVisible] = useState(false);

    const handleBuyCreditsClick = () => {
        setBuyCreditsModalVisible(true);
    };

    const handleBuyCreditsConfirm = (creditData) => {
        console.log('ManageEnterpriseSubscription: handleBuyCreditsConfirm called', creditData);
        setBuyCreditsModalVisible(false);
        if (onBuyCredits) {
            onBuyCredits(creditData);
        } else {
            console.log('ManageEnterpriseSubscription: onBuyCredits not provided');
        }
    };

    return (
        <>
            <Modal
                centered
                closable={false}
                maskClosable={false}
                visible={visible}
                onCancel={onClose}
                footer={null}
                className="manage-enterprise-subscription-modal"
                destroyOnClose={true}
                width={600}>

                <div className="enterprise-manage-content">
                    <div className="modal-close-btn" onClick={onClose}>
                        <CloseOutlined />
                    </div>
                    
                    <div className="manrope f-24 w-400 black-085 lh-32 mb-16">
                        ALL3D Enterprise Subscription
                    </div>

                    {/* <div className="manrope f-32 w-600 black-085 lh-40 mb-16">
                        $4,800 <span className="manrope f-18 w-400 black-085">billed annually</span>
                    </div> */}

                    <div className="manrope f-16 w-400 black-085 lh-24 mb-24">
                        Your enterprise subscription includes full access to the ALL3D platform and 3D services tailored to your needs
                    </div>

                    <div className="mb-24">
                        <a className="manrope f-16 w-400 blue lh-24 cursor-pointer" onClick={onViewContract}>
                            View Current Contract
                        </a>
                    </div>

                    <div className="enterprise-manage-actions">
                        <Button
                            className="buy-credits-button"
                            onClick={handleBuyCreditsClick}>
                            Buy credits
                        </Button>
                        <Button
                            className="contact-sales-button"
                            onClick={onContactSales}>
                            Contact Sales
                        </Button>
                    </div>

                    <div className="text-center mt-24">
                        <a 
                            className="manrope f-14 w-400 red lh-22 cursor-pointer" 
                            onClick={onCancelSubscription}>
                            Request to cancel subscription
                        </a>
                    </div>
                </div>
            </Modal>

            <BuyCreditsModal
                visible={buyCreditsModalVisible}
                onClose={() => setBuyCreditsModalVisible(false)}
                onConfirm={handleBuyCreditsConfirm}
                planData={planData}
            />
        </>
    );
};

export default ManageEnterpriseSubscription;
